// Block-visibility evaluation for the player.
//
// The real implementation lives in @little-loop/content-engine so the player,
// admin-web preview, share-web, and the resolution reference engine all share
// one rule evaluator (no drift). This wrapper is kept because
// `evaluateVisibility` is the player's established call site.
import { evaluateRule } from '@little-loop/content-engine';
/**
 * Evaluate a block's `visible_when` rule against the resolved variable values
 * for the current learner. Returns true when the block should be shown.
 */
export function evaluateVisibility(rule, variableValues) {
    return evaluateRule(rule, variableValues);
}
